'use strict';

import './modules/polyfill-foreach.js';
import './modules/keyboard-mouse.js';
import './modules/search-toggle.js';
import './modules/navigation.js';
import './modules/site-header.js';
import './modules/details-element.js';
import './modules/entrance-effects.js';
import './modules/parallax.js';
import './modules/featured-menu.js';
import './modules/key-numbers.js';
import './modules/our-fleet-block.js';
import './modules/news-page.js';
import './modules/footer-menu.js';
import './modules/employees.js';
import './modules/custom-select.js';
import './modules/map-links.js';
import './modules/iframeResizer.js';
import './modules/vacancies.js';